 
 

  <!-- main app container -->
<div class="card m-3"> 
  <div class="card-body">

    
      
   <img src="./assets/bpl-lumber-stack_orig.png"  *ngIf="isMobile" width="20%" style="float: right; vertical-align: top;">
   
   <img src="./assets/bpl-lumber-stack_orig.png"  *ngIf="!isMobile" width="10%" style="float: right; vertical-align: top;">
    
   
   
   <h2>Distributor</h2><br><br>
    <a routerLink="/addeditdistributor">
      <button mat-button color="primary"><mat-icon>add</mat-icon>ADD</button></a>
    <div class="mat-elevation-z8">
     
      <br>
      <br>
      
      <table class="table table-striped table-sm">
          <thead>
              <tr>
                  <!-- <th><a (click)="sortBy('id')">Id {{sortIcon('id')}}</a></th> -->
                  <th><a (click)="sortBy('name')">First Name {{sortIcon('name')}}</a></th> 
                  <th></th>
                  <th></th>
                </tr>
          </thead>
          <tbody>
              <tr *ngFor="let item of distributors">
                  <!-- <td>{{item.id}}</td> -->
                  <td>{{item.name}}</td> 
                  <td>
                    <button (click)="editDistributor(item)">Edit</button>
                  </td> 
                  <td>
                    <button (click)="deleteDistributor(item)">Delete</button>
                  </td>
              </tr>
              <tr *ngIf="loading">
                  <td colspan="5" class="text-center py-5">
                      <span class="spinner-border spinner-border-lg align-center"></span>
                  </td>
              </tr>
          </tbody>
      </table>
  </div>
  <!-- <div class="card-footer text-center pb-0 pt-3">
      <pagination [items]="items" (changePage)="onChangePage($event)"></pagination>
  </div> -->
</div>
 